import './style.scss'
import { useState } from 'react'
import { ScreenContainer } from "src/style"
import { AllDisputes, DisputeChats, DisputeDetails } from "src/component"
import utility from "src/utils/utility"
import { IDispute_ServiceRequest } from 'src/model'

const Dispute: React.FC = () => {
    const [displayType, setDisplayType] = useState('disputes')
    const [selectedDisputeOrRequest, setSelectedDisputeOrRequest] = useState<IDispute_ServiceRequest | null>(null)

    return (
        <>
            <ScreenContainer
                leftPadding='2.5' rightPadding='2.5'
                topPadding='1.5' bottomPadding='1.5'
            >
                { displayType === 'disputes' ?
                    <AllDisputes 
                        toggleTo={setDisplayType} 
                        handleOnSelect={setSelectedDisputeOrRequest}
                    /> :
                        displayType === 'dispute-details' ?
                            <DisputeDetails 
                                toggleTo={setDisplayType}
                                data={selectedDisputeOrRequest} 
                            /> :
                            displayType === 'dispute-chats' ?
                                <DisputeChats toggleTo={setDisplayType} />
                                : null
                }
            </ScreenContainer>
        </>
    )
}

export default utility.routeData('dispute_request', 'Dispute and Request', <Dispute/>)